import confetti from "canvas-confetti"

export default class {
  constructor(canvas) {
    this.canvas = canvas

    // Create a single confetti instance with useWorker: false
    this.confettiInstance = confetti.create(canvas || null, {
      resize: true,
      useWorker: false,
    })

    if (this.canvas) {
      this.canvas.confetti = this.canvas.confetti || this.confettiInstance

      this.canvas.confetti({
        spread: 70,
        origin: { y: 1.2 },
      })
    }
  }

  bottomCannon(seconds, config = {}) {
    this.rescue(() => {
      const fn = this.canvas?.confetti || this.confettiInstance
      const duration = seconds * 1000
      const end = Date.now() + duration

      ;(function frame() {
        fn({
          particleCount: 10,
          angle: 90,
          spread: 150,
          origin: { x: 0.5, y: 1 },
          ...config,
        })

        // keep going until end time
        if (Date.now() < end) {
          requestAnimationFrame(frame)
        }
      })()
    })
  }

  fireworks(seconds) {
    this.rescue(() => {
      const duration = seconds * 1000
      const animationEnd = Date.now() + duration
      const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 2090 }

      function randomInRange(min, max) {
        return Math.random() * (max - min) + min
      }

      const interval = setInterval(() => {
        const timeLeft = animationEnd - Date.now()

        if (timeLeft <= 0) {
          return clearInterval(interval)
        }

        const particleCount = 200 * (timeLeft / duration)
        // since particles fall down, start a bit higher than random
        const fn = this.canvas?.confetti || this.confettiInstance
        fn(
          Object.assign({}, defaults, {
            particleCount,
            origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
          }),
        )
        fn(
          Object.assign({}, defaults, {
            particleCount,
            origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
          }),
        )
      }, 250)
    })
  }

  school(seconds) {
    this.rescue(() => {
      const duration = seconds * 1000
      const end = Date.now() + duration
      const fn =
        this.canvas?.confetti ||
        this.confettiInstance(function frame() {
          fn({
            particleCount: 5,
            angle: 60,
            spread: 55,
            origin: { x: 0, y: 1 },
          })

          fn({
            particleCount: 5,
            angle: 120,
            spread: 55,
            origin: { x: 1, y: 1 },
          })

          if (Date.now() < end) {
            requestAnimationFrame(frame)
          }
        })()
    })
  }

  rescue(callback) {
    try {
      callback()
    } catch (e) {
      // ignore error
    }
  }
}
